import AxiosClient from "../../../services/axios.services";

class EmployeeMonitorServices {
  getEmployeeMonitor = (params) =>
    AxiosClient.get("/api/app/monitor_colaborador/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  validateEmployeeDescriptor = (params) =>
    AxiosClient.get("/api/app/validacion_decriptor_colaborador/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getEmployeeMonitorById = (id) =>
    AxiosClient.get(`/api/app/monitor_colaborador/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveEmployeeMonitor = (data) =>
    AxiosClient.post("/api/app/monitor_colaborador/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editEmployeeMonitor = (id, data) =>
    AxiosClient.put(`/api/app/monitor_colaborador/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  saveEmployeeMonitorGD = (data) =>
    AxiosClient.post("/api/app/evaluacion_archivo_plan_accion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editEmployeeMonitorGD = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_archivo_plan_accion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteEmployeeMonitor = (id) =>
    AxiosClient.delete(`/api/app/monitor_colaborador/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new EmployeeMonitorServices();
